/* jshint esnext: true */
import Tab from '../bootstrap/tab';
import { $document } from '../utils/environment';
import { defaultEasing } from '../global/animation';
import { scrollTo } from '../global/scrollTo';

export default function(firstBlood) {
    Ractive.DEBUG = /unminified/.test(function(){/*unminified*/});

    // Add special easing to jQuery
    $.extend(
        $.easing,
        {
            easeOutCubic: defaultEasing,
            easeOutSine: defaultEasing,
            stadEasing: defaultEasing
        }
    );

    let hash = window.location.hash;
    hash && $('a[data-target="' + hash + '"]').tab('show');

    // hunt(document.getElementsByClassName('js-hunt'), {
    //     in: function() {
    //         this.classList.add('is-show');
    //     }
    // });

    if (firstBlood) {
        $document.on('click', '.js-scrollto', (event) => {
            let $this = $(event.currentTarget);
            let $target = $($this.data('scrollto-target'));
            let $container = $($this.data('scrollto-container'));
            scrollTo($target, {
                $container: $container
            });
        })
    }
}
